/**
 * How we label party / org roles in the UI (PRIMARY vs SECONDARY).
 * Registrant org role is derived from ``primary_id``, not a stored type.
 */

/** OMT/AMS and similar org-user tables: Primary vs Secondary. */
export function formatAccountTypeForOrgUserList(
  accountType: string | null | undefined,
): string {
  if (!accountType) return "";
  return accountType.toUpperCase() === "SECONDARY" ? "Secondary" : "Primary";
}

export function formatAccountTypeForRegistrantUserList(
  accountType: string | null | undefined,
): string {
  return formatAccountTypeForOrgUserList(accountType);
}
